const Order = () => {
    return (
        <div className="text-center p-6">
            <h1 className="text-3xl font-bold text-red-600">🛒 订购</h1>
            <p className="text-gray-700 mt-2">想吃煎饼果子？快来下单吧！</p>
        </div>
    );
};

export default Order;